/**
 * @licence
 * Copyright 2021 ModBros OG
 * Licenced under apache Licence, Version 2.0
 */

/**
 * Do not edit directly!
 * Generated on Wed Oct 13 2021 19:02:58 GMT+0200 (Central European Summer Time)
 */

export const cssVariables = `
--modbros-color-layer-primer: hsl(240, 11%, 10%);
--modbros-color-layer-background: hsl(240, 11%, 14%);
--modbros-color-layer-default: hsl(240, 11%, 17%);
--modbros-color-layer-highlight: hsl(240, 11%, 20%);
--modbros-color-container-background: hsl(240, 11%, 14%);
--modbros-color-container-default: hsl(240, 11%, 23%);
--modbros-color-container-highlight: hsl(240, 11%, 25%);
--modbros-color-container-brand: hsl(359, 77%, 64%);
--modbros-color-container-overlay: hsla(240, 18%, 11%, 0.8);
--modbros-color-container-input: hsl(240, 11%, 29%);
--modbros-color-container-input-hover: hsl(240, 13%, 35%);
--modbros-color-container-input-disabled: hsl(240, 3%, 23%);
--modbros-color-action-standard-default: hsl(240, 16%, 42%);
--modbros-color-action-standard-default-hover: hsl(240, 16%, 35%);
--modbros-color-action-standard-default-disabled: hsl(0, 0%, 30%);
--modbros-color-action-primary-default: hsl(8, 60%, 50%);
--modbros-color-action-primary-default-hover: hsl(8, 60%, 42%);
--modbros-color-action-primary-default-disabled: hsl(8, 22%, 35%);
--modbros-color-action-minimal-default: hsla(0, 0%, 0%, 0);
--modbros-color-action-minimal-default-hover: hsla(240, 12%, 10%, 0.66);
--modbros-color-action-minimal-default-disabled: hsla(0, 0%, 21%, 0.66);
--modbros-color-action-critical-default: hsl(3, 100%, 60%);
--modbros-color-action-critical-default-hover: hsl(3, 100%, 56%);
--modbros-color-action-critical-default-disabled: hsl(3, 25%, 55%);
--modbros-color-action-success-default: hsl(150, 75%, 40%);
--modbros-color-action-success-default-hover: hsl(150, 75%, 36%);
--modbros-color-action-success-default-disabled: hsl(150, 10%, 50%);
--modbros-color-text-default: hsl(240, 12%, 80%);
--modbros-color-text-action-default: hsl(200, 95%, 66%);
--modbros-color-text-action-default-hover: hsl(200, 100%, 70%);
--modbros-color-text-action-default-active: hsl(200, 75%, 55%);
--modbros-color-text-emphasized: hsl(0, 0%, 100%);
--modbros-color-text-on-color: hsl(240, 10%, 100%);
--modbros-color-text-on-color-contrast: hsl(240, 10%, 10%);
--modbros-color-text-brand: hsl(8, 60%, 50%);
--modbros-color-text-disabled: hsl(240, 4%, 55%);
--modbros-color-text-error: hsl(3, 100%, 60%);
--modbros-color-text-success: hsl(150, 75%, 40%);
--modbros-color-text-warning: hsl(32, 100%, 55%);
--modbros-color-border-default: hsla(240, 14%, 50%, 0.3);
--modbros-color-border-active: hsl(0, 0%, 100%);
--modbros-color-border-disabled: hsl(240, 4%, 33%);
--modbros-color-border-focused: hsl(200, 95%, 66%);
--modbros-color-border-error: hsl(3, 100%, 60%);
--modbros-color-border-success: hsl(150, 75%, 40%);
--modbros-color-gradient-default: linear-gradient(90deg, #3F3F5A 0%, #303040 100%);
--modbros-color-gradient-brand: linear-gradient(90deg, #FF3300 0%, #B6075E 100%);
--modbros-typography-default-family: Open Sans, Helvetica, sans-serif;
--modbros-typography-default-weight: 400;
--modbros-typography-default-text-decoration: none;
--modbros-typography-default-text-transform: none;
--modbros-typography-default-line-height: 1.375;
--modbros-typography-default-size: 1rem;
--modbros-typography-default-emphasized-family: Open Sans, Helvetica, sans-serif;
--modbros-typography-default-emphasized-weight: 600;
--modbros-typography-default-emphasized-text-decoration: none;
--modbros-typography-default-emphasized-text-transform: none;
--modbros-typography-default-emphasized-line-height: 1.375;
--modbros-typography-default-emphasized-size: 1rem;
--modbros-typography-small-family: Open Sans, Helvetica, sans-serif;
--modbros-typography-small-weight: 300;
--modbros-typography-small-text-decoration: none;
--modbros-typography-small-text-transform: none;
--modbros-typography-small-line-height: 1.1667;
--modbros-typography-small-size: 0.75rem;
--modbros-typography-small-emphasized-family: Open Sans, Helvetica, sans-serif;
--modbros-typography-small-emphasized-weight: 600;
--modbros-typography-small-emphasized-text-decoration: none;
--modbros-typography-small-emphasized-text-transform: none;
--modbros-typography-small-emphasized-line-height: 1.1667;
--modbros-typography-small-emphasized-size: 0.75rem;
--modbros-typography-headline-1-family: Rubik, sans-serif;
--modbros-typography-headline-1-weight: 500;
--modbros-typography-headline-1-text-decoration: none;
--modbros-typography-headline-1-text-transform: none;
--modbros-typography-headline-1-line-height: 1.15;
--modbros-typography-headline-1-size: 4.75rem;
--modbros-typography-headline-2-family: Rubik, sans-serif;
--modbros-typography-headline-2-weight: 500;
--modbros-typography-headline-2-text-decoration: none;
--modbros-typography-headline-2-text-transform: none;
--modbros-typography-headline-2-line-height: 1.125;
--modbros-typography-headline-2-size: 3rem;
--modbros-typography-headline-3-family: Rubik, sans-serif;
--modbros-typography-headline-3-weight: 700;
--modbros-typography-headline-3-text-decoration: none;
--modbros-typography-headline-3-text-transform: none;
--modbros-typography-headline-3-line-height: 1.125;
--modbros-typography-headline-3-size: 2rem;
--modbros-typography-headline-4-family: Rubik, sans-serif;
--modbros-typography-headline-4-weight: 500;
--modbros-typography-headline-4-text-decoration: none;
--modbros-typography-headline-4-text-transform: none;
--modbros-typography-headline-4-line-height: 1.1;
--modbros-typography-headline-4-size: 1.5rem;
--modbros-typography-headline-5-family: Rubik, sans-serif;
--modbros-typography-headline-5-weight: 500;
--modbros-typography-headline-5-text-decoration: none;
--modbros-typography-headline-5-text-transform: none;
--modbros-typography-headline-5-line-height: 1.15;
--modbros-typography-headline-5-size: 1.25rem;
--modbros-typography-headline-6-family: Rubik, sans-serif;
--modbros-typography-headline-6-weight: 700;
--modbros-typography-headline-6-text-decoration: none;
--modbros-typography-headline-6-text-transform: none;
--modbros-typography-headline-6-line-height: 1.2;
--modbros-typography-headline-6-size: 1rem;
`;